import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Bidding, BiddingStatus } from '../../model/bidding';
import { Company } from '../../model/company';
import {MatDatepickerModule} from '@angular/material/datepicker';


import * as jsPDF from 'jspdf';

import * as html2canvas from 'html2canvas';
import { AuthenticationService } from '../../services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-biddings-report',
  templateUrl: './biddings-report.component.html',
  styleUrls: ['./biddings-report.component.css'],
  providers: [DBService, AuthenticationService]
})
export class BiddingsReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  biddings: Bidding[];
  displayBiddings: Bidding[];

  loading: boolean;

  emptyData: boolean;

  earnedCount: number;
  lostCount: number;
  waitingCount: number;
  refusedCount: number;
  inProgressCount: number;

  totalCount: number;
  effectiveCount: number;

  earnedAmount: number;
  lostAmount: number;

  userCompanyUID: string;

  public pieChartLabels: string[] = ['Ganhas', 'Perdidas', 'Recusadas pelo cliente', 'Aguardando cliente', 'Em andamento (aceitas pelo cliente)'];
  public pieChartData: number[] = [300, 500, 100, 100, 50];
  public pieChartType = 'pie';
  public pieChartColors: Array<any> = [ { backgroundColor: ['#4CAF50', '#F44336', '#ff9800', '#CCC', '#4787ed']}];

  constructor(private dbService: DBService, private authService: AuthenticationService) {
    this.companyFilter = '0';
    this.emptyData = true;

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadCompanies();
    this.loadActivities();
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
          this.companyFilter = this.userCompanyUID;
        } else {
          this.companies = companies;
        }
      });
  }

  private loadActivities() {
    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => this.biddings = biddings);
  }

  search() {
    this.emptyData = false;

    this.displayBiddings = this.biddings
      .filter(a => a.biddingDate >= this.initialDate)
      .filter(a => a.biddingDate <= this.endDate);

    if (this.companyFilter != '' && this.companyFilter != '0') {
      this.displayBiddings = this.displayBiddings.filter(a => a.companyUID == this.companyFilter);
    }
    console.log(this.displayBiddings)
    this.initData();
  }

  private initData() {
    this.loading = true;

    this.earnedCount = this.displayBiddings.filter(b => b.status == BiddingStatus.EARNED).length;
    this.lostCount = this.displayBiddings.filter(b => b.status == BiddingStatus.LOST).length;
    this.waitingCount = this.displayBiddings.filter(b => b.status == BiddingStatus.NEW).length;
    this.refusedCount = this.displayBiddings.filter(b => b.status == BiddingStatus.REFUSED).length;
    this.inProgressCount = this.displayBiddings.filter(b => b.status == BiddingStatus.ACCEPTED).length;
  
    this.totalCount = this.displayBiddings.length;
    this.effectiveCount = this.earnedCount + this.inProgressCount + this.lostCount;

    this.earnedAmount = this.displayBiddings 
      .filter(b => b.status == BiddingStatus.EARNED)
      .map(b => b.earningPrice)
      .reduce((v1, v2) => v1 + v2, 0);

    this.lostAmount = this.displayBiddings
      .filter(b => b.status == BiddingStatus.LOST)
      .map(b => b.lostPrice)
      .reduce((v1, v2) => v1 + v2, 0);

    this.pieChartData = [this.earnedCount, this.lostCount, this.refusedCount, this.waitingCount, this.inProgressCount];

    this.loading = false;
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => {

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
    
  }

  exportPDF() {
    html2canvas(document.getElementById('content'), { width: 750, height: 915 }).then((canvas) => {
      const img = canvas.toDataURL('image/jpeg');
      const doc = new jsPDF('p', 'mm', 'a4');
      const width = doc.internal.pageSize.width;
      const height = doc.internal.pageSize.height;
      doc.addImage(canvas, 'JPEG', 0, 0, 208, 275);
      doc.save(`Relatório de Licitações.pdf`);
  });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/biddings-report/biddings-report.component.ts